<tm-split-button small_screens_icon="layers_filled"
                 [options]="backgroundLayers$ | async"
                 [emptyLabel]="initiallyCheckedLabels$ | async"
                 [selectedOption]="selectedBackgroundNodeId$ | async"
                 [in3D]="in3D()"
                 [layersWithoutWebMercator]="layersWithoutWebMercator()"
                 (optionSelected)="backgroundChanged($event)"></tm-split-button>
